
if (!customElements.get('split-layout')) {
  class SplitLayout extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
      this.resizeHandler = null;
    }
    connectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();

        this.resizeHandler = () => {
          if (this.splittext) {
            this.splittext.revert();

            const allHeadings = this.querySelectorAll('h3.heading');
            const allParagraphs = this.querySelectorAll('.rte p');
            const headingsWithoutBreaks = Array.from(allHeadings).filter(h => !h.innerHTML.includes('<br>'));

            if (headingsWithoutBreaks.length || allParagraphs.length) {
              this.splittext = new SplitText([...headingsWithoutBreaks, ...allParagraphs], {
                type: 'lines, words',
                linesClass: 'line-child'
              });
            }
          }
        };

        window.addEventListener('resize', this.resizeHandler);
      }
    }
    disconnectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        if (this.tl) this.tl.kill();
        if (this.splittext) this.splittext.revert();
        if (this.resizeHandler) {
          window.removeEventListener('resize', this.resizeHandler);
        }
      }
    }
    prepareAnimations() {
      let section = this;
      let property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';

      document.fonts.ready.then(function() {
        const allHeadings = section.querySelectorAll('h3.heading');
        const allParagraphs = section.querySelectorAll('.rte p');

        const headingsWithoutBreaks = Array.from(allHeadings).filter(h => !h.innerHTML.includes('<br>'));

        if (headingsWithoutBreaks.length || allParagraphs.length) {
          section.splittext = new SplitText([...headingsWithoutBreaks, ...allParagraphs], {
            type: 'lines, words',
            linesClass: 'line-child'
          });
        }

          section.tl = gsap.timeline({
            scrollTrigger: {
              trigger: section,
              start: "top center"
            }
          });

          let button_offset = 0;

          if (section.querySelectorAll('.subheading').length) {
            section.querySelectorAll('.subheading').forEach((subheading) => {
              const targetOpacity = parseFloat(getComputedStyle(subheading.closest('.split-layout--block')).getPropertyValue('--text-opacity')) / 100 || 1;
              section.tl.fromTo(subheading, {
                opacity: 0
              }, {
                duration: 0.75,
                opacity: targetOpacity
              }, 0);
            });

            button_offset += 0.5;
          }

          const headingsWithBreaks = Array.from(section.querySelectorAll('h3.heading')).filter(h => h.innerHTML.includes('<br>'));
          const headingsWithoutBreaksForAnim = section.querySelectorAll('h3.heading:not([style*="display"])');

          if (headingsWithBreaks.length) {
            headingsWithBreaks.forEach((heading) => {
              const targetOpacity = parseFloat(getComputedStyle(heading.closest('.split-layout--block')).getPropertyValue('--text-opacity')) / 100 || 1;
              section.tl.fromTo(heading, {
                autoAlpha: 0
              }, {
                duration: 0.75,
                autoAlpha: targetOpacity
              }, 0);
            });
            button_offset += 0.75;
          }

          if (section.querySelectorAll('h3.heading .line-child div').length) {
            let heading_duration = 0.8 + ((section.querySelectorAll('h3.heading .line-child div').length - 1) * 0.08);
            section.tl
              .set(section.querySelectorAll('h3.heading'), {
                visibility: 'visible'
              }, 0)
              .from(section.querySelectorAll('h3.heading .line-child div'), {
                duration: heading_duration,
                yPercent: '100',
                stagger: 0.08
              }, 0);
            button_offset += heading_duration;
          }

          if (section.querySelector('.rte p')) {
            let p_duration = 0.8 + ((section.querySelectorAll('.rte p .line-child div').length - 1) * 0.02);
            section.tl
              .set(section.querySelectorAll('.rte p'), {
                visibility: 'visible'
              }, 0)
              .from(section.querySelectorAll('.rte p .line-child div'), {
                duration: p_duration,
                yPercent: '100',
                stagger: 0.02
              }, 0);
            button_offset += p_duration;
          }

          if (section.querySelectorAll('.button')) {
            let i = 1;
            section.querySelectorAll('.button').forEach((item) => {
              section.tl.fromTo(item, {
                autoAlpha: 0
              }, {
                duration: 0.5,
                autoAlpha: 1
              }, ((button_offset * 0.4) + (i - 1) * 0.1));
              i++;
            });
          }
      });

      if (section.querySelector('.thb-parallax-image')) {
        gsap.fromTo(section.querySelectorAll('.thb-parallax-image'), {
          y: '-8%'
        }, {
          y: '8%',
          ease: 'none',
          scrollTrigger: {
            trigger: section,
            scrub: 1,
            start: () => `top bottom`,
            end: () => `bottom top+=${property}`,
            onUpdate: () => {
              property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';
            }
          }
        });
      }
    }
  }
  customElements.define('split-layout', SplitLayout);
}
